/* global fbq */
import h from 'react-hyperscript';
import R from 'ramda';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Form from 'react-jsonschema-form';
import FieldTemplate from './FieldTemplate';
import { customUiSchema, widgets, jsonSchema } from './schema';
import schemaBuilder, { baseQuestions, baseUiSchema, baseWidgets } from './schema-builder';
import { v4 } from 'uuid';
import classNames from 'classnames';
import { browserHistory } from 'react-router';

import Submit from '../Submit';

import styles from './application-form.css';

const log = R.bind(console.log, console);

function component({ mutate, createTestInput, course }) {
    const { defaultSchema, defaultUiSchema } = schemaBuilder(R.merge(baseQuestions, R.prop('properties', jsonSchema)),
baseUiSchema, course.questions.edges);
    const uiSchema = R.merge(defaultUiSchema, customUiSchema);

    const onSubmit = ({formData: { firstName, lastName, email, secondaryEmail, ...rest}}) => {
        const question = (field) => R.path(['properties', field, 'title'], defaultSchema);
        const answer = (field) => R.prop(field, rest);

        const answers = R.reduce(
            (answers, field) => R.assoc(field, {question: question(field), answer: answer(field)}, answers),
            {},
            R.keys(rest)
        );

        mutate({
            variables: {
                clientMutationId: v4(),
                firstName,
                lastName,
                email,
                secondaryEmail,
                answers,
                state: 'pending',
                courseId: course.id
            }
        })
        .then(({data: { applyToCourse: { newSubmission }}}) => {
            // const submissionId = fromGlobalId(newSubmission.id).id;
            // browserHistory.push(`/course/${submissionId}/success`);
            if (window.fbq) {
              fbq('track', 'CompleteRegistration');
            }
            browserHistory.push('/contact/success');
        });
    };

    return (
        h(Form, {
            className: classNames(styles.form),
            schema: defaultSchema,
            FieldTemplate,
            widgets: R.merge(baseWidgets, widgets),
            uiSchema,
            onChange: log('changed'),
            onError: log('errors'),
            onSubmit
        }, [
            h(Submit)])
    );
}

export default graphql(gql`
  mutation createNewApplication( $clientMutationId: String!, $firstName: String!, $lastName: String!, $email: String!, $secondaryEmail: String, $answers: JSON!, $courseId: ID!) {
        applyToCourse(input: {
            clientMutationId: $clientMutationId,
            application: {
                firstName: $firstName,
                lastName: $lastName,
                email: $email,
                secondaryEmail: $secondaryEmail,
                answers: $answers,
                courseId: $courseId
            }
        }) {
            clientMutationId
            newSubmission {
                id,
                answers
            }
        }
    }
    `)(component);



/** WEBPACK FOOTER **
 ** ./src/ApplicationForm/index.js
 **/